import React from "react"

const PrivacyPolicy: React.FC = (): JSX.Element => {
  return (
    <section id="privacy-policy" className="mb-8">
      <div className="space-y-6">
        <div>
          <h2 className="text-lg font-bold text-black mb-4">1. GIỚI THIỆU</h2>
          <div className="space-y-3 text-gray-800 text-sm leading-relaxed">
            <p>
              Chính sách Bảo mật Thông tin ("Chính sách") áp dụng cho Ứng dụng{" "}
              <strong>TuTiMi App</strong> và Website <strong>TuTiMi.com</strong>{" "}
              và hoặc bất kỳ trang web hoặc ứng dụng khác (nếu có) bao gồm các
              ứng dụng trên điện thoại di động liên quan đến thương hiệu hoặc
              sản phẩm của TuTiMi mà hướng dẫn người xem hoặc người dùng đến
              Chính sách này.
            </p>
            <p>
              Ứng dụng <strong>TuTiMi App</strong> và Website{" "}
              <strong>TuTiMi.com</strong> thuộc quyền sở hữu của Công ty TuTiMi
              Coffee & Tea (được gọi tắt bằng thuật ngữ "TuTiMi" hoặc "TuTiMi
              Coffee & Tea").
            </p>
            <p>
              TuTiMi Coffee & Tea cam kết bảo vệ và tôn trọng quyền riêng tư
              liên quan đến dữ liệu cá nhân của Quý Khách hàng trong khuôn khổ
              quy định pháp luật và khả năng cho phép của thương hiệu. Chính
              sách này được ban hành nhằm giúp Quý Khách hàng hiểu rõ các thức
              TuTiMi Coffee & Tea thu thập, sử dụng, tiết lộ hoặc xử lý các dữ
              liệu cá nhân do Quý Khách hàng cung cấp thông qua việc truy cập
              và/hoặc sử dụng Ứng dụng <strong>TuTiMi App</strong> và Website
              <strong>TuTiMi.com</strong> trong bất kỳ thời điểm nào.
            </p>
            <p>
              Bằng việc sử dụng dịch vụ, đăng ký tài khoản hoặc truy cập bất kỳ
              Ứng dụng và Website thuộc sở hữu của TuTiMi có áp dụng Chính sách
              này, Quý Khách hàng được xem là chấp nhận toàn bộ nội dung được mô
              tả trong Chính sách này.
            </p>
          </div>
        </div>

        <div>
          <h2 className="text-lg font-bold text-black mb-4">
            2. MỤC ĐÍCH THU THẬP THÔNG TIN
          </h2>
          <div className="space-y-3 text-gray-800 text-sm leading-relaxed">
            <p>
              Mục đích TuTiMi Coffee & Tea thu thập, lưu trữ và xử lý thông tin
              của bạn để dùng trong các trường hợp sau đây:
            </p>

            <div>
              <h3 className="font-semibold text-black mb-2 text-sm">
                Chia sẻ dữ liệu nội bộ:
              </h3>
              <p className="mb-3">
                TuTiMi Coffee & Tea có thể chia sẻ thông tin thu thập được cho
                Công ty TuTiMi và các công ty thành viên với mục đích quản lý,
                phân tích và quyết định thích hợp, bao gồm các quyết định liên
                quan đến việc mở rộng và xúc tiến các đề xuất sản phẩm và dịch
                vụ, đơn hàng của TuTiMi Coffee & Tea hoặc đáp ứng yêu cầu khách
                hàng.
              </p>
            </div>

            <div>
              <h3 className="font-semibold text-black mb-2 text-sm">
                Làm việc với các Nhà Cung Cấp:
              </h3>
              <p className="mb-3">
                TuTiMi Coffee & Tea có thể chia sẻ thông tin của bạn với các Nhà
                Cung Cấp Dịch Vụ mà họ cung cấp cho TuTiMi Coffee & Tea các dịch
                vụ hỗ trợ, chẳng hạn như máy chủ trang web, gửi email, vị trí
                bản đồ, quy trình gửi thư, bưu chính, chuẩn bị và giao hàng theo
                đơn, và phân tích.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default PrivacyPolicy
